import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, CheckSquare, MessageCircle, Settings, LogOut, Smile, MessageSquare, Megaphone, Filter, BookOpen } from 'lucide-react';

interface SidebarProps {
  currentUser?: any;
  onLogout?: () => void;
}

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
    isActive
      ? 'bg-blue-guestby text-black-guestby font-medium'
      : 'text-grey-guestby hover:bg-slate-700 hover:text-white'
  }`;

const Sidebar: React.FC<SidebarProps> = ({ currentUser, onLogout }) => {
  const mainItems = [
    { to: '/', icon: Home, label: 'Dashboard', end: true },
    { to: '/guests', icon: Users, label: 'Guests', end: true },
    { to: '/chats', icon: MessageSquare, label: 'Inbox', end: true },
    { to: '/tasks', icon: CheckSquare, label: 'Tasks', end: true },
    { to: '/knowledge', icon: BookOpen, label: 'Knowledge', end: true },
    { to: '/feedbacks', icon: Smile, label: 'Feedback', end: true },
    { to: '/settings', icon: Settings, label: 'Settings', end: true },
  ];

  return (
    <div className="w-64 bg-black-guestby text-white h-full shadow-lg">
      <div className="p-6">
        <div className="flex items-center space-x-2 mb-8">
          <MessageCircle className="h-8 w-8 text-blue-guestby" />
          <h1 className="text-xl font-bold text-white">Hermes</h1>
        </div>

        <nav className="space-y-1">
          {mainItems.slice(0, 2).map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              <item.icon className="h-5 w-5 shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}

          <div className="pt-3 pb-1">
            <p className="px-4 text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Marketing
            </p>
            <NavLink to="/campaigns" end className={linkClass}>
              <Megaphone className="h-5 w-5 shrink-0" />
              <span>Campaigns</span>
            </NavLink>
            <NavLink to="/campaigns/segments" end className={linkClass}>
              <span className="w-5 shrink-0 inline-flex justify-center">
                <Filter className="h-4 w-4 opacity-80" />
              </span>
              <span className="pl-1 text-[15px]">Audience segments</span>
            </NavLink>
          </div>

          {mainItems.slice(2).map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              <item.icon className="h-5 w-5 shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="absolute bottom-0 left-0  p-6 ">
        {currentUser && (
          <div className="mb-4">
            <p className="text-sm text-white font-medium">{currentUser.name}</p>
            <p className="text-xs text-grey-guestby">{currentUser.email}</p>
            <p className="text-xs text-slate-500 capitalize">{currentUser.role}</p>
          </div>
        )}

        {onLogout && (
          <button
            onClick={onLogout}
            className="flex items-center space-x-2 text-grey-guestby hover:text-white transition-colors duration-200 mb-4"
          >
            <LogOut className="h-4 w-4" />
            <span className="text-sm">Logout</span>
          </button>
        )}

        <p className="text-sm text-grey-guestby">AI-Powered Concierge</p>
        <p className="text-xs text-slate-500 mt-1">v1.0.0</p>
      </div>
    </div>
  );
};

export default Sidebar;
